module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAUCAMAAACpgK3LAAAAilBMVEUAAAAEAAEJAQIKAQIOAQMjAwYpAwgsBAgwBAkxBAk1BAo5BQo+BQtEBg1HBg1KBg5OBg5SBw9aBxFlCBNvCRRxCRV0ChV1ChaACxiBCxiCCxiGCxmHCxmTDBuVDBucDR2hDR6lDh6oDh+qDh+sDiCvDiCwDyCxDyG0DyG/ECPDECTHECXMESbOESZkvVteAAAAlklEQVQoz7XRNwKDMBBE0SVIZEQWOYso7n89F5QLruxpX/cHri+Dn+BxXtd5PGHZbo7WtpqztSXCsXS9zDAyzy1HhD2jEAAEQFmPUMQEAACAxAIjozdShnHl1o0WXxEuTeirAKofNgvCnYtKt229EnxHOEV5lhKSZnk04UL1PCSKkgxz/dy2M83uNbwsCvn+ipR/+BPtA6hnVOP0aNCcAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/al.png
// module id = 766
// module chunks = 0